import { render } from "./Files.vue?vue&type=template&id=e99f88e6&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"

import "./Files.vue?vue&type=style&index=0&id=e99f88e6&lang=scss&scoped=true"

import exportComponent from "/opt/gitea/webhooker/hooks/dscontrol/kraken/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99f88e6"]])

export default __exports__